import React from "react";
import {
  Table,
  Button,
  Card,
  Row,
  Col,
  Image,
  Dropdown,
  FormControl,
  Modal,
  Offcanvas,
} from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { ImHome } from "react-icons/im";
import { TfiAngleRight } from "react-icons/tfi";
import { Form, InputGroup } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import upload from "../assets/images/icons/upload.png";
import success from "../assets/images/icons/success.png";
import { MdOutlineDownloadForOffline } from "react-icons/md";
import {
  FaSearch,
  FaCalendarAlt,
  FaEllipsisH,
  FaDownload,
  FaTrash,
} from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import searchIcon from "../assets/images/icons/search.png";
import { CiCalendar } from "react-icons/ci";
import { MdOutlineFileDownload } from "react-icons/md";
import { RiDeleteBin5Line } from "react-icons/ri";
import { BiBorderRadius } from "react-icons/bi";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FaEllipsisV } from "react-icons/fa";
import FloatingActionButton from "../components/FloatingActionButton";
import { bulkUploadService } from "../services/bulkUploadService";
import connectorService from "../services/connectorService";
import { userService } from "../services/userService";
import { accountService } from "../services/accountService";
import { formatDateForAPI } from "../utils/dateUtils";

const BulkUpload = ({ isVisible, onClose, isActive = true }) => {
  const [file, setFile] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [bulkUploadHistory, setBulkUploadHistory] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [accountId, setAccountId] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isDownloadingTemplate, setIsDownloadingTemplate] = useState(false);
  const [isDownloadingResult, setIsDownloadingResult] = useState(null);
  const successResetTimeoutRef = useRef(null);
  const uploadAbortControllerRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [showIndividualForm, setShowIndividualForm] = useState(false);
  const [formData, setFormData] = useState({
    urlTracking: false,
    individualTracking: false,
  });

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const [showSftpImportModal, setShowSftpImportModal] = useState(false);
  const [sftpConfigs, setSftpConfigs] = useState([]);
  const [sftpLoading, setSftpLoading] = useState(false);
  const [selectedSftpConfigId, setSelectedSftpConfigId] = useState("");
  const [remoteFilePath, setRemoteFilePath] = useState("");
  const [isImportingFromSftp, setIsImportingFromSftp] = useState(false);

  const openSftpImportModal = async () => {
    setShowSftpImportModal(true);
    if (!accountId) return;
    setSftpLoading(true);
    try {
      const response = await connectorService.getConfigurationsByType(
        accountId,
        "import"
      );
      const configs = response?.data || response || [];
      setSftpConfigs(Array.isArray(configs) ? configs : []);
      if (Array.isArray(configs) && configs.length > 0) {
        setSelectedSftpConfigId(configs[0].id);
      }
    } catch (error) {
      console.error("Error loading SFTP configurations:", error);
      toast.error("Failed to load SFTP configurations");
    } finally {
      setSftpLoading(false);
    }
  };

  const csvStringToFormData = (csvString, fileName = "imported.csv") => {
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const file = new File([blob], fileName, { type: "text/csv" });
    setFile(file);
    // const formData = new FormData();
    // formData.append("file", file);

    // return formData;
  };

  const handleImportFromSftp = async () => {
    if (!selectedSftpConfigId || !remoteFilePath.trim()) {
      toast.error(
        "Select an SFTP configuration and enter the remote file path"
      );
      return;
    }
    setIsImportingFromSftp(true);
    try {
      const resp = await bulkUploadService.importFromSftp({
        accountId: accountId,
        sftpConfigId: selectedSftpConfigId,
        remoteFilePath: remoteFilePath.trim(),
      });
      const csvContent = resp?.data?.metadata?.fileContent;

      if (!csvContent) {
        toast.error("CSV content not found in import response");
        return;
      }

      // Convert CSV → FormData
      const formData = csvStringToFormData(
        csvContent,
        resp.data.fileName || "sftp-import.csv"
      );
      toast.success("Import started successfully");
      setShowSftpImportModal(false);
      setRemoteFilePath("");
      // Refresh history after import trigger
      if (accountId && isActive) {
        await fetchBulkUploadHistory(startDate, endDate);
      }
    } catch (error) {
      console.error("Error importing from SFTP:", error);
      toast.error(
        error.response?.data?.message || "Failed to import from SFTP"
      );
    } finally {
      setIsImportingFromSftp(false);
    }
  };

  const handleDownloadTemplate = async () => {
    setIsDownloadingTemplate(true);
    try {
      const token = localStorage.getItem("token");
      const response = await bulkUploadService.downloadTemplate();

      const blob = new Blob([response]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "template.csv";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    } catch (error) {
      console.error("Error downloading template:", error);
      toast.error("Failed to download template");
    } finally {
      setIsDownloadingTemplate(false);
    }
  };

  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      const rejection = rejectedFiles[0];
      if (rejection.errors.some(e => e.code === 'file-too-large')) {
        setErrorMessage(
          "File size exceeds 200MB limit. Please upload a smaller file."
        );
      } else {
        setErrorMessage(
          "Invalid file type! Only CSV and Excel files are allowed."
        );
      }
      return;
    }
    setFile(acceptedFiles[0]);
    setUploadSuccess(false);
    setErrorMessage("");
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    maxSize: 200 * 1024 * 1024, // 200MB
    accept: {
      "text/csv": [".csv"],
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
  });

  const fetchBulkUploadHistory = async (fromDate = null, toDate = null) => {
    try {
      const fromDateStr = formatDateForAPI(fromDate);
      const toDateStr = formatDateForAPI(toDate);
      const zeroBasedPage = Math.max(currentPage - 1, 0);
      const historyResponse = await bulkUploadService.getBulkUploadHistory(
        accountId,
        fromDateStr,
        toDateStr,
        zeroBasedPage,
        itemsPerPage,
        search
      );

      // Normalize response to handle both paged and array formats
      const content =
        historyResponse?.content ??
        historyResponse?.data ??
        historyResponse ??
        [];
      const totalPagesResp =
        historyResponse?.totalPages ??
        historyResponse?.data?.totalPages ??
        (Array.isArray(content) ? Math.ceil(content.length / itemsPerPage) : 0);
      const totalElementsResp =
        historyResponse?.totalElements ??
        historyResponse?.data?.totalElements ??
        (Array.isArray(content) ? content.length : 0);

      setBulkUploadHistory(Array.isArray(content) ? content : []);
      setTotalPages(totalPagesResp || 0);
      setTotalElements(totalElementsResp || 0);
      return {
        content: Array.isArray(content) ? content : [],
        totalElements: totalElementsResp || 0,
      };
    } catch (error) {
      console.error("Error fetching bulk upload history:", error);
      throw error;
    }
  };

  const handleSubmit = async () => {
    if (file) {
      setIsUploading(true);
      try {
        const token = localStorage.getItem("token");
        const formData = new FormData();
        formData.append("file", file);

        // Create an AbortController to allow canceling the upload
        uploadAbortControllerRef.current = new AbortController();
        const response = await bulkUploadService.uploadBulkUrls(
          formData,
          uploadAbortControllerRef.current.signal
        );

        if (response.status === 200) {
          setUploadSuccess(true);
          setCurrentPage(1);

          await fetchBulkUploadHistory(startDate, endDate);

          toast.success("File uploaded successfully");

          // Auto-reset dropzone after short success display (kept)
          if (successResetTimeoutRef.current) {
            clearTimeout(successResetTimeoutRef.current);
          }
          successResetTimeoutRef.current = setTimeout(() => {
            setUploadSuccess(false);
            successResetTimeoutRef.current = null;
          }, 2000);
        }
      } catch (error) {
        console.error("Error uploading file:", error.response.data);
        setErrorMessage("Failed to upload file. Please try again.");
        toast.error(error.response.data);
        setUploadSuccess(false);
      } finally {
        // Always clear the selected file after submit attempt
        setFile(null);
        setIsUploading(false);
        // Clear the abort controller
        uploadAbortControllerRef.current = null;
      }
    }
  };

  const handleCancel = () => {
    // Clear selected file and any related UI flags/messages
    setFile(null);
    setUploadSuccess(false);
    setErrorMessage("");
    if (successResetTimeoutRef.current) {
      clearTimeout(successResetTimeoutRef.current);
      successResetTimeoutRef.current = null;
    }
    // If uploading, abort the request
    if (isUploading && uploadAbortControllerRef.current) {
      try {
        uploadAbortControllerRef.current.abort();
      } catch (e) {}
      uploadAbortControllerRef.current = null;
      setIsUploading(false);
      toast.info("Upload canceled");
    }
  };

  const data = [
    {
      id: 1,
      title: "Miami development",
      date: "Thu 12 Dec",
      records: "10,000",
      status: "Completed",
    },
    {
      id: 2,
      title: "Prague apartment",
      date: "Thu 12 Dec",
      records: "10,000",
      status: "Completed",
    },
    {
      id: 3,
      title: "Czech redevelopment",
      date: "Wed 04 Dec",
      records: "50,000",
      status: "Completed",
    },
    {
      id: 4,
      title: "Paris apartment blocks",
      date: "Tue 03 Dec",
      records: "5,00,000",
      status: "Pending",
    },
    {
      id: 5,
      title: "India corporate property",
      date: "Mon 15 Jan",
      records: "1,00,000",
      status: "Pending",
    },
  ];

  const statusColors = {
    Completed: "success",
    Pending: "warning",
  };

  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    const lastMonth = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      today.getDate()
    );
    return lastMonth;
  });
  const [endDate, setEndDate] = useState(() => new Date());

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault(); // Prevent form submission and page refresh
  };

  const handleDateChange = async (date, isStartDate) => {
    let newStartDate = startDate;
    let newEndDate = endDate;

    if (isStartDate) {
      newStartDate = date;
      if (endDate && date > endDate) {
        newEndDate = date;
        setEndDate(date);
      }
      setStartDate(date);
    } else {
      newEndDate = date;
      if (startDate && date < startDate) {
        newStartDate = date;
        setStartDate(date);
      }
      setEndDate(date);
    }

    setCurrentPage(1);

    if (accountId && isActive) {
      try {
        await fetchBulkUploadHistory(newStartDate, newEndDate);
      } catch (error) {
        console.error("Error fetching history with new date range:", error);
      }
    }
  };

  const getFilteredHistory = () => {
    return bulkUploadHistory.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  };

  const filteredHistory = getFilteredHistory();
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredHistory; // server-side pagination already applied

  useEffect(() => {
    const fetchAccountIdAndHistory = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const decodedToken = jwtDecode(token);
        const username = decodedToken.sub;

        const userResponse = await userService.getUserByUsername(username);

        const fetchedAccountId = userResponse.accountId;
        setAccountId(fetchedAccountId);

        // Use proper date formatting without timezone issues
        const fromDateStr = formatDateForAPI(startDate);
        const toDateStr = formatDateForAPI(endDate);
        const zeroBasedPage = Math.max(currentPage - 1, 0);
        const historyResponse = await bulkUploadService.getBulkUploadHistory(
          fetchedAccountId,
          fromDateStr,
          toDateStr,
          zeroBasedPage,
          itemsPerPage,
          search
        );
        const content =
          historyResponse?.content ??
          historyResponse?.data ??
          historyResponse ??
          [];
        const totalPagesResp =
          historyResponse?.totalPages ??
          historyResponse?.data?.totalPages ??
          (Array.isArray(content)
            ? Math.ceil(content.length / itemsPerPage)
            : 0);
        const totalElementsResp =
          historyResponse?.totalElements ??
          historyResponse?.data?.totalElements ??
          (Array.isArray(content) ? content.length : 0);
        setBulkUploadHistory(Array.isArray(content) ? content : []);
        setTotalPages(totalPagesResp || 0);
        setTotalElements(totalElementsResp || 0);
      } catch (error) {
        console.error("Error fetching history:", error);
      } finally {
        setIsLoading(false);
      }
    };

    // Only fetch data when the component is active
    if (isActive) {
      fetchAccountIdAndHistory();
    }
  }, [isActive]);

  useEffect(() => {
    return () => {
      if (successResetTimeoutRef.current) {
        clearTimeout(successResetTimeoutRef.current);
        successResetTimeoutRef.current = null;
      }
    };
  }, []);

  const handleDownloadResult = async (resultFileName, itemId) => {
    setIsDownloadingResult(itemId);
    try {
      const token = localStorage.getItem("token");
      const response = await bulkUploadService.downloadResult(resultFileName);

      const blob = new Blob([response]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = resultFileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      
      toast.success("Result file downloaded successfully");
    } catch (error) {
      console.error("Error downloading result:", error);
      toast.error("Failed to download result");
    } finally {
      setIsDownloadingResult(null);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  // Trigger fetch when search text changes (server-side filtering)
  useEffect(() => {
    if (accountId && isActive) {
      fetchBulkUploadHistory(startDate, endDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  // Refetch when page changes for server-side pagination
  useEffect(() => {
    if (accountId && isActive) {
      fetchBulkUploadHistory(startDate, endDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handleDelete = async () => {
    if (!itemToDelete) return;

    setIsDeleting(true);
    try {
      const token = localStorage.getItem("token");
      await bulkUploadService.deleteBulkUploadItem(itemToDelete.id);

      if (isActive) {
        await fetchBulkUploadHistory(startDate, endDate);
      }

      toast.success("File deleted successfully");

      handleClose();
      setItemToDelete(null);
    } catch (error) {
      console.error("Error deleting file:", error);
      toast.error("Failed to delete file. Please try again.");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <div className="main-container p-0">
        <Row className="">
          <Col lg={12}>
            <Card className="br-radius-0">
              <Card.Header className="d-flex fw-600 bg-white br-radius-12 rounded-bottom-0 pt-3 pb-3 fs-20 br-color-EAECEE">
                <div className="d-flex align-items-center flex-grow-1">
                  Bulk Upload
                  <div className="ms-auto d-flex align-items-center gap-4">
                    <Button
                      variant="success"
                      className="me-2"
                      onClick={handleDownloadTemplate}
                      disabled={isDownloadingTemplate}
                    >
                      {isDownloadingTemplate ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Downloading...
                        </>
                      ) : (
                        <>
                          Download Template{" "}
                          <MdOutlineDownloadForOffline className="fs-14" />
                        </>
                      )}
                    </Button>
                    <Button
                      variant="outline-success"
                      className="me-2"
                      onClick={openSftpImportModal}
                    >
                      Import from SFTP
                    </Button>
                  </div>
                </div>
              </Card.Header>

              <Card.Body>
                <div
                  {...getRootProps()}
                  className="p-4  border-dashed d-flex align-items-center justify-content-center bg-f1f1f1 text-center rounded"
                  style={{
                    minHeight: "157px",
                    borderColor: "#f1f1f1",
                    border: " 1px dashed #A8B0B9",
                    cursor: "pointer",
                  }}
                >
                  <input {...getInputProps()} />
                  {uploadSuccess ? (
                    <>
                      <div className="text-success">
                        <i
                          className="bi bi-check-circle-fill"
                          style={{ fontSize: "2rem" }}
                        ></i>
                      </div>
                      <div className="flex-column justify-content-center">
                        <Image
                          width="46"
                          className="mb-3 d-block m-auto"
                          src={success}
                        />
                        <p className="fs-12 mb-0">File Uploaded Successfully</p>
                      </div>
                    </>
                  ) : file ? (
                    <p className="fs-12 mb-0">{file.name}</p>
                  ) : isDragActive ? (
                    <p>Drop the file here...</p>
                  ) : (
                    <div>
                      <Image width="56" className="mb-3" src={upload} />
                      <p className="fs-12 mb-0">
                        Drag & Drop your filled template or <br />
                        Click here to upload
                      </p>
                    </div>
                  )}
                </div>
                <Form.Text className="d-flex text-242D35 fs-12 mt-2">
                  <strong className="GeneralSansMedium">Note </strong> :
                  <ul className="ps-3 fs-11">
                    <li>
                      For better Performance 5,00,000 records can be uploaded at
                      a time, and file must be in CSV format.
                    </li>
                    <li>
                      If you have trouble uploading the filled template, please
                      raise a Support Ticket and our support team will help you.
                    </li>
                  </ul>
                </Form.Text>

                <div className="d-flex justify-content-end mt-3">
                  <Button
                    variant="outline-secondary"
                    className="me-2"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="success"
                    onClick={handleSubmit}
                    disabled={!file || isUploading}
                  >
                    {isUploading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Uploading...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col lg={12}>
            <Card className="br-radius-12 shadow-none border-0">
              <Card.Header className="d-flex fw-600 bg-white br-radius-12 rounded-bottom-0  pb-3 fs-20 br-color-EAECEE">
                Bulk Upload History
                {/* <Button variant="outline-success ms-auto" className="me-2">
                                    Upload URL <MdOutlineDownloadForOffline />
                                </Button> */}
              </Card.Header>

              <div className="mt-3">
                <div className="d-flex justify-content-between mb-3 align-items-center gap-2">
                  <div className="d-flex justify-content-start ">
                    <Form
                      className="search-box position-relative"
                      style={{
                        border: "1px solid #EAECEE",
                        borderRadius: "8px",
                      }}
                      onSubmit={handleSearchSubmit}
                    >
                      <FormControl
                        type="text"
                        placeholder="Search by file name..."
                        value={search}
                        onChange={handleSearch}
                        className="search-field mr-sm-2 GeneralSansMedium p-0 fw-500"
                      />
                      <Image
                        src={searchIcon}
                        className="position-absolute end-0 me-2"
                        style={{ width: "15px", top: "12px" }}
                      />
                    </Form>
                    <div
                      className="d-flex align-items-center ms-3"
                      style={{
                        border: "1px solid #EAECEE",
                        borderRadius: "8px",
                        width: "250px",
                        position: "relative",
                      }}
                    >
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => handleDateChange(date, true)}
                        className="form-control border-0 br-radius-32 me-2 search-fields mr-sm-2 GeneralSansMedium fw-500"
                        placeholderText="Start Date"
                        maxDate={endDate || new Date()}
                        dateFormat="MMM dd, yyyy"
                      />

                      <span className="mx-2">⇆</span>

                      <DatePicker
                        selected={endDate}
                        onChange={(date) => handleDateChange(date, false)}
                        className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                        placeholderText="End Date"
                        minDate={startDate}
                        maxDate={new Date()}
                        dateFormat="MMM dd, yyyy"
                      />

                      <div
                        className="border-0 bg-transparent fs-12 d-flex align-items-center pe-2"
                        style={{ cursor: "pointer" }}
                        onClick={async () => {
                          const today = new Date();
                          const lastMonth = new Date(
                            today.getFullYear(),
                            today.getMonth() - 1,
                            today.getDate()
                          );
                          setStartDate(lastMonth);
                          setEndDate(today);
                          setCurrentPage(1);

                          if (accountId && isActive) {
                            try {
                              await fetchBulkUploadHistory(lastMonth, today);
                            } catch (error) {
                              console.error(
                                "Error fetching history after date reset:",
                                error
                              );
                            }
                          }
                        }}
                        title="Reset to default date range"
                      >
                        <FaCalendarAlt
                          className={startDate || endDate ? "text-danger" : ""}
                          style={{ fontSize: "14px", marginLeft: "-18px" }}
                        />
                      </div>
                    </div>

                    {search && (
                      <Button
                        variant="light"
                        className="ms-2"
                        onClick={async () => {
                          setSearch("");
                          const today = new Date();
                          const lastMonth = new Date(
                            today.getFullYear(),
                            today.getMonth() - 1,
                            today.getDate()
                          );
                          setStartDate(lastMonth);
                          setEndDate(today);
                          setCurrentPage(1);

                          if (accountId && isActive) {
                            try {
                              await fetchBulkUploadHistory(lastMonth, today);
                            } catch (error) {
                              console.error(
                                "Error fetching history after clearing filters:",
                                error
                              );
                            }
                          }
                        }}
                        title="Clear all filters"
                      >
                        Clear Filters
                      </Button>
                    )}
                  </div>
                </div>

                <Table hover responsive>
                  <thead className="table-success custom-thead">
                    <tr>
                      <th>Sr.No.</th>
                      <th>File Name</th>
                      <th>Created On</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="5" className="text-center py-4">
                          <div className="d-flex justify-content-center align-items-center">
                            <div
                              className="spinner-border text-primary me-2"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            Loading history...
                          </div>
                        </td>
                      </tr>
                    ) : filteredHistory.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          {bulkUploadHistory.length === 0
                            ? "No records found"
                            : "No matching records found"}
                        </td>
                      </tr>
                    ) : (
                      currentItems.map((item, index) => (
                        <tr key={item.id}>
                          <td>{indexOfFirstItem + index + 1}</td>
                          <td>{item.inputFileName}</td>
                          <td>
                            <CiCalendar className="text-A8B0B9 fs-18 align-middle mb-1 me-1" />
                            {new Date(item.createdAt).toLocaleDateString(
                              "en-US",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }
                            )}{" "}
                            {new Date(item.createdAt).toLocaleTimeString(
                              "en-US",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              }
                            )}
                          </td>
                          <td>
                            <span
                            // className={`badge bg-warning`}

                            className={`badge ${
                              item.processingStatus === "SUCCESS"
                                ? "bg-success"
                                : item.processingStatus === "IN_PROGRESS"
                                ? "bg-warning"
                                : "bg-danger"
                            }`}
                          >
                              {item.processingStatus}
                            </span>
                          </td>
                          <td>

                            <Dropdown className="cust-drop">
                              <Dropdown.Toggle
                                variant="link"
                                id="dropdown-basic"
                              >
                                <FaEllipsisV className="text-A8B0B9 fs-12" />
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {item.resultS3FileName && (
                                  <Dropdown.Item
                                    className="fs-12 pt-2 pb-2"
                                    onClick={() =>
                                      handleDownloadResult(
                                        item.resultS3FileName,
                                        item.id
                                      )
                                    }
                                    disabled={isDownloadingResult === item.id}
                                  >
                                    {isDownloadingResult === item.id ? (
                                      <>
                                        <span
                                          className="spinner-border spinner-border-sm me-2"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        Downloading...
                                      </>
                                    ) : (
                                      <>
                                        <MdOutlineFileDownload className="align-middle fs-14 me-1" />
                                        Download Result
                                      </>
                                    )}
                                  </Dropdown.Item>
                                )}
                                <Dropdown.Item
                                  href="#"
                                  onClick={() => {
                                    setItemToDelete(item);
                                    handleShow();
                                  }}
                                  className="fs-12 pt-2 pb-2"
                                >
                                  <RiDeleteBin5Line className="align-middle fs-12 me-1" />
                                  Delete
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                            
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {!isLoading && bulkUploadHistory.length > 0 && (
        <div className="d-flex justify-content-between align-items-center mt-3 pb-5 px-3">
          <div className="text-muted fs-12">
            Showing {indexOfFirstItem + 1} to{" "}
            {Math.min(indexOfLastItem, totalElements)} of {totalElements}{" "}
            entries
          </div>
          <div className="d-flex justify-content-center">
            <nav>
              <ul className="pagination mb-0">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(1)}
                    disabled={currentPage === 1}
                  >
                    &laquo;
                  </button>
                </li>
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    disabled={currentPage === 1}
                  >
                    &lt;
                  </button>
                </li>
                {(() => {
                  let startPage = Math.max(currentPage - 1, 1);
                  let endPage = Math.min(startPage + 2, totalPages);

                  if (endPage === totalPages) {
                    startPage = Math.max(endPage - 2, 1);
                  }

                  return [...Array(endPage - startPage + 1)].map((_, idx) => (
                    <li
                      key={startPage + idx}
                      className={`page-item ${
                        currentPage === startPage + idx ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(startPage + idx)}
                      >
                        {startPage + idx}
                      </button>
                    </li>
                  ));
                })()}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    disabled={currentPage === totalPages}
                  >
                    &gt;
                  </button>
                </li>
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(totalPages)}
                    disabled={currentPage === totalPages}
                  >
                    &raquo;
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )}

      {/* Modal Component */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="sm"
        className="text-center"
      >
        <Modal.Body>
          <p className="fs-15 GeneralSansSemibold mb-1 mt-2">Confirmation</p>
          <p className="fs-12 mb-0">
            Are you sure you want to delete this file?
          </p>
          {itemToDelete && (
            <p className="fw-600 mt-2 mb-0 fs-14">
              {itemToDelete.inputFileName}
            </p>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 pb-4 justify-content-center">
          <Button
            variant="outline-secondary"
            className="me-2 br-radius-8"
            onClick={() => {
              setShow(false);
              setItemToDelete(null);
            }}
            disabled={isDeleting}
          >
            Don't delete
          </Button>
          <Button
            variant="success"
            style={{ fontFamily: "General Sans Medium" }}
            className="br-radius-8"
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Deleting...
              </>
            ) : (
              "YES, delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSftpImportModal}
        onHide={() => setShowSftpImportModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-16">Import from SFTP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {sftpLoading ? (
            <div className="d-flex align-items-center">
              <span className="spinner-border spinner-border-sm me-2" /> Loading
              configurations...
            </div>
          ) : (
            <>
              <Form.Group className="mb-3">
                <Form.Label className="fs-12">SFTP Configuration</Form.Label>
                <Form.Select
                  value={selectedSftpConfigId}
                  onChange={(e) => setSelectedSftpConfigId(e.target.value)}
                >
                  <option value="">Select Configuration</option>
                  {sftpConfigs.map((cfg) => (
                    <option key={cfg.id} value={cfg.id}>
                      {cfg.name || `${cfg.host} (${cfg.username})`}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group>
                <Form.Label className="fs-12">Remote File Path</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g., /imports/bulk.csv"
                  value={remoteFilePath}
                  onChange={(e) => setRemoteFilePath(e.target.value)}
                />
                <Form.Text className="fs-11">
                  CSV file path accessible by the configured SFTP server.
                </Form.Text>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowSftpImportModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handleImportFromSftp}
            disabled={isImportingFromSftp || sftpLoading}
          >
            {isImportingFromSftp ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />{" "}
                Importing...
              </>
            ) : (
              "Import"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <FloatingActionButton
        onSingleUrlClick={() => {}}
        onBulkUrlClick={() => {}}
      />

      <Offcanvas
        show={isVisible}
        onHide={onClose}
        placement="end"
        className="custom-offcanvas"
      >
        {/* Offcanvas content */}
      </Offcanvas>
    </>
  );
};

export default BulkUpload;
